export const pricing = {
  title: "Elegí tu plan",
  subtitle: "Seleccioná el plan perfecto para tus necesidades de IA",
  monthly: "Mensual",
  yearly: "Anual",
  yearlyDiscount: "25% de descuento",
  contactUs: "Contactanos",
  getStarted: "Comenzar",
  mostPopular: "Más Popular",
  currentPlan: "Plan Actual",
  tiers: {
    free: {
      name: "Free",
      description: "Perfecto para pruebas y exploración",
      price: "R$ 0.00", // Consider keeping the currency for consistency
      features: [
        "Política de límites diarios",
        "Acceso a modelos gratuitos",
        "Todas las funciones disponibles",
      ],
    },
    prepaid: {
      name: "Prepago",
      description: "Pagá solo por lo que usás, sin compromiso, a partir de",
      price: "R$ 36,00", // Consider keeping the currency
      features: [
        "Depositá cualquier valor",
        "Pagá solo por lo que usás",
        "Los créditos nunca vencen",
        "Sin compromiso mensual",
        "Soporte básico",
        "Análisis detallado del uso",
      ],
    },
    subscription: {
      name: "Pro",
      description: "Mejor valor para usuarios regulares",
      price: "R$ 120,00", // Consider keeping the currency
      yearlyPrice: "R$ 1080,00", // Consider keeping the currency
      period: "/mes",
      yearlyPeriod: "/año",
      features: [
        "Todos los modelos premium incluidos",
        "Sin límites de uso",
        "Soporte prioritario",
        "Análisis avanzado",
      ],
    },
    enterprise: {
      name: "Enterprise",
      description: "Soluciones personalizadas para grandes equipos",
      price: "Personalizado",
      features: [
        "Acceso a la API",
        "Entrenamiento de modelo personalizado",
        "Soporte dedicado",
        "Garantía SLA",
        "Integraciones personalizadas",
        "Descuentos por volumen",
      ],
    },
  },
  secondaryTitle: "¿Qué se puede hacer con R$ 36?",
  secondarySubtitle:
    "R$ 36 son suficientes para crear muchas imágenes y videos.",
  canBeDoneWith36Credits: [
    {
      title: "Generar 1800 imágenes 512x512",
    },
    {
      title: "0.4M tokens GPT-4o",
    },
    {
      title: "Generar 13 videos de 5 segundos",
    },
    {
      title: "0.8M tokens Claude 3.5 Sonnet",
    },
    {
      title: "1200 tareas de Re-ranking corporativo (Cohere)",
    },
    {
      title: "3.4M tokens de Maritaca (Sabiá 3)",
    },
    {
      title: "18 tareas de Decoración de Interiores",
    },
    {
      title: "12M tokens DeepSeek V3",
    },
  ],
};
